import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import LandingPage from './pages/LandingPage';
import QuestionnaireRouter from './components/questionnaires/QuestionnaireRouter';
import ResultsPage from './pages/ResultsPage';
import QuestionnaireReviewPage from './pages/QuestionnaireReviewPage';
import DashboardPage from './pages/DashboardPage';
import AuthPage from './pages/AuthPage';
import TestAuthPage from './pages/TestAuthPage';
import AdminPage from './pages/AdminPage';
import AdminReportPage from './pages/AdminReportPage';
import TestResultsPage from './pages/TestResultsPage';
import LiveLandingPage from './pages/LiveLandingPage';
import LiveCreateSessionPage from './pages/LiveCreateSessionPage';
import LiveAnimatorPage from './pages/LiveAnimatorPage';
import LiveParticipantPage from './pages/LiveParticipantPage';
import LiveResultPage from './pages/LiveResultPage';

function AppContent() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="App">
        <div className="container" style={{ marginTop: '2rem', textAlign: 'center' }}>
          <div className="loading">Chargement...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/test-auth" element={<TestAuthPage />} />
          <Route 
            path="/questionnaire/:id" 
            element={<QuestionnaireRouter />} 
          />
          <Route 
            path="/results/:id" 
            element={<ResultsPage />} 
          />
          <Route 
            path="/review/:id" 
            element={isAuthenticated ? <QuestionnaireReviewPage /> : <AuthPage />} 
          />
          <Route 
            path="/dashboard" 
            element={isAuthenticated ? <DashboardPage /> : <AuthPage />} 
          />
          <Route
            path="/admin"
            element={isAuthenticated ? <AdminPage /> : <AuthPage />}
          />
          <Route
            path="/admin/report/:userId/:questionnaireId"
            element={isAuthenticated ? <AdminReportPage /> : <AuthPage />}
          />
          <Route
            path="/test-results"
            element={<TestResultsPage />}
          />
          {/* Live group exercise (orientation-axis ternary) */}
          {/* In dev, the animator routes skip auth — backend swa-auth.js
              mirrors this so the whole flow works locally without SWA. */}
          <Route path="/live" element={<LiveLandingPage />} />
          <Route
            path="/live/new"
            element={(isAuthenticated || process.env.NODE_ENV === 'development') ? <LiveCreateSessionPage /> : <AuthPage />}
          />
          <Route
            path="/live/animator/:code"
            element={(isAuthenticated || process.env.NODE_ENV === 'development') ? <LiveAnimatorPage /> : <AuthPage />}
          />
          <Route path="/live/:code/result" element={<LiveResultPage />} />
          <Route path="/live/:code" element={<LiveParticipantPage />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;